import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { costantValue } from "../../../services/forms-template.service";
import { ComponentService } from "../../../services/component.service";
import { messagefromComponent } from "../../../class/appinterface";
import { Apiservice } from "../../../services/api.service";

@Component({
    selector: "app-crm-dashboard",
    templateUrl: "./crm-dashboard.component.html",
    styleUrls: ["./crm-dashboard.component.css"],
})
export class CrmDashboardComponent implements OnInit {
    @Input() service: string = 'diarioAttivitaDashBoardGrid';
    @Output() onAllEvent: EventEmitter<any> = new EventEmitter<any>()
    @Input() api: string = 'diario';
    @Input() gridHeight: string = '600';
    @Input() costantValues: costantValue[] = []
    @Input() soloRicercaGlobale: boolean = true
    @Input() ricerca: boolean = false
    @Input() gridWidth
    @Input() isAdvancedXlsExportAvailable: boolean = false
    @Input() isExportDocxAvailable: boolean = true
    @Input() isExportExcelAvailable: boolean = true
    @Input() isExportPDFAvailable: boolean = true
    @Input() filter: string = '?$filter=((Stato eq 0) OR (Stato eq 1))';
    @Input() dataInput: any;

    constructor(
        private componentService: ComponentService,
        private apiService: Apiservice
    ) { }
    ngOnInit(): void { }

    buttonEventAnagrafica(event) {
        if (event && event.name === 'apriContatto') {
            console.log(event)
            this.getCodAss(event.row.data.CodContatto).then((resp) => {
                const risposta: any = resp
                const message: messagefromComponent = {
                    codeMessage: 1,
                    traceMessage: 'apriContatto',
                    destComponent: 'CrmComponent',
                    Data: { Items: [risposta.data] }
                }
                this.componentService.emitMessage(message)
            })
        }
    }

    getCodAss(codContatto: number) {
        return this.apiService.GetApiRest(`contatti/${codContatto}`)
    }
}
